const NAME = 'page';

export const FETCH_PAGE_REQUESTED = `${NAME}/_PAGE_REQUESTED`;
export const FETCH_PAGE_RECEIVED = `${NAME}/_PAGE_RECEIVED`;
export const FETCH_PAGE_FAILED = `${NAME}/_PAGE_FAILED`;
